export enum ToneOfVoiceEnum {
  FORMAL = 'formal',
  INFORMAL = 'informal'
}
